import { V1Service } from '@zelos/codegen/apis';
import { resetAtomAccessCookie } from './access-cookie';
import { isServerSide } from './environment';
import { throwIfNotTypedApiError } from './typed-api-error';

export const refreshSession = Object.assign<Function, Record<'refreshRequest', Promise<void> | null>>(async () => {
  if (isServerSide) return;
  try {
    const refreshRequest = refreshSession.refreshRequest ??= V1Service.v1UsersTokenRefreshCreate().then(() => resetAtomAccessCookie());
    await refreshRequest;
    document.cookie = 'need_refresh=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/';
  } catch (error) {
    throwIfNotTypedApiError(error);
  } finally {
    refreshSession.refreshRequest = null;
  }
}, { refreshRequest: null });
